import React, { useState, useEffect } from 'react'

import Map from './Map.js';
import Numbers from './Numbers.js';
import ConnAttemps from './ConnAttemps.js';
import TopConsumers from './TopConsumers.js';
import TopFlavours from './TopFlavours.js';
import { endpoints, makeUrl } from './endpoints.js'

function Overview() {
  let defaultData = {
    "MapData": [],
    "TotalConsumptions": {"Count": 0},
    "TotalIPv4s": {"Count": 0},
    "TotalHostnames": {"Count": 0},
    "LatestConsumptions": [],
    "TopConsumers": [],
    "TopFlavours": [],
  };

  const [publicDashboardData, setPublicDashboardData] = useState(defaultData);

  useEffect(() => {
    fetch(makeUrl(endpoints.data))
      .then(res => res.json())
      .then((data) => {
        setPublicDashboardData(data);
      })
      .catch(console.log)
  }, [setPublicDashboardData]);

  return (
    <div className="container">
      <h3 className="has-text-weight-bold is-size-3 honey-text-font-family-common honey-text-common">
        Overview
      </h3>
      <div className="container">
        <Map data={publicDashboardData["MapData"]} />
        <Numbers
          countTotalConsumptions={publicDashboardData["TotalConsumptions"]["Count"]}
          countIPv4s={publicDashboardData["TotalIPv4s"]["Count"]}
          countHostnames={publicDashboardData["TotalHostnames"]["Count"]}
        />
        <ConnAttemps latestConsumptions={publicDashboardData["LatestConsumptions"]} />
        <div className="container block">
          <div className="columns">
            <div className="column">
              <TopConsumers topConsumers={publicDashboardData["TopConsumers"]} />
            </div>
            <div className="column">
              <TopFlavours topFlavours={publicDashboardData["TopFlavours"]} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Overview;
